<template>
  <div class="rj-page-card behavior-replay-detail">
    <div class="rj-page-card__title">
      行为回放详情
      <span class="session-id">会话：{{ sessionId }}</span>
    </div>
    <div class="rj-page-card__content">
      <div class="toolbar">
        <el-button size="mini" @click="goBack">
          返回列表
        </el-button>
        <el-button size="mini" :loading="loading" @click="loadEvents">
          刷新
        </el-button>
        <span class="meta">共 {{ events.length }} 个事件</span>
        <span v-if="errorMessage" class="error">{{ errorMessage }}</span>
      </div>
      <div v-loading="loading" class="player-wrapper">
        <div v-show="!loading && events.length" ref="player" class="player-target" />
        <div v-if="!loading && !events.length && !errorMessage" class="empty">
          该会话暂无可回放的事件
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RRWebPlayer from 'rrweb-player';
import 'rrweb-player/dist/style.css';
import { unpack } from '@rrweb/packer';
import { getReplayEvents } from '@/API/behaviorLog';

export default {
  name: 'BehaviorReplayDetail',
  props: {
    sessionId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      events: [],
      errorMessage: '',
      player: null
    };
  },
  mounted () {
    this.loadEvents();
  },
  beforeDestroy () {
    this.destroyPlayer();
  },
  methods: {
    async loadEvents () {
      if (!this.sessionId) {
        this.errorMessage = '缺少会话ID，无法回放';
        return;
      }
      this.loading = true;
      this.errorMessage = '';
      try {
        const events = await getReplayEvents(this.sessionId);
        this.events = this.normalizeEvents(events || []);
        this.$nextTick(() => {
          this.renderPlayer();
        });
      } catch (e) {
        this.events = [];
        this.errorMessage = e.message || '查询回放数据失败';
        this.destroyPlayer();
      } finally {
        this.loading = false;
      }
    },
    /**
     * 录制端可能使用 rrweb pack 压缩事件，回放前需要统一解压
     */
    normalizeEvents (rawEvents) {
      const list = [];
      let failed = 0;
      rawEvents.forEach((item) => {
        if (!item) {
          return;
        }
        if (typeof item === 'string') {
          try {
            list.push(unpack(item));
          } catch (e) {
            failed++;
          }
          return;
        }
        list.push(item);
      });
      if (failed) {
        this.$message.warning(`有 ${failed} 个事件解码失败，已跳过`);
      }
      return list;
    },
    renderPlayer () {
      if (!this.events.length || !this.$refs.player) {
        return;
      }
      this.destroyPlayer();
      const containerWidth = (this.$refs.player.parentNode && this.$refs.player.parentNode.clientWidth) || 1200;
      const width = Math.max(Math.min(containerWidth - 20, 1400), 800);
      const height = Math.max(Math.round(window.innerHeight * 0.68), 480);
      try {
        this.player = new RRWebPlayer({
          target: this.$refs.player,
          props: {
            events: this.events,
            width,
            height,
            autoPlay: true,
            speedOption: [1, 2, 4, 8],
            showController: true,
            skipInactive: true
          }
        });
      } catch (e) {
        this.errorMessage = `回放渲染失败：${e.message || e}`;
      }
    },
    destroyPlayer () {
      if (this.player && typeof this.player.$destroy === 'function') {
        try {
          this.player.$destroy();
        } catch (e) {
          // 忽略销毁异常
        }
      }
      this.player = null;
      if (this.$refs.player) {
        this.$refs.player.innerHTML = '';
      }
    },
    goBack () {
      this.$router.push({ name: 'behaviorReplay' });
    }
  }
};
</script>

<style lang="scss" scoped>
.session-id {
  margin-left: 12px;
  font-size: 12px;
  font-weight: normal;
  color: #909399;
}

.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  .meta {
    margin-left: 12px;
    font-size: 12px;
    color: #909399;
  }

  .error {
    margin-left: 12px;
    font-size: 12px;
    color: #f56c6c;
  }
}

.player-wrapper {
  min-height: 480px;
}

.player-target {
  display: inline-block;
}

.empty {
  padding: 120px 0;
  text-align: center;
  color: #909399;
}
</style>
